/* eslint-disable linebreak-style */
import React from 'react';

const Footer = () => (
  <footer className="footer bg-light">
    <div className="container">
      <div className="row">
        <div className="col-lg-6 h-100 text-center text-lg-left my-auto">
          <p className="footer-text small mb-4 mb-lg-0">
            {/* eslint-disable-next-line max-len */}
            This website is developed by Eli Lilly and Company Ltd and is intended for UK Healthcare Professionals and Other Relevant Decision Makers only
          </p>
          <ul className="list-inline mb-2">
            <li className="list-inline-item">
              <span>CMAT-55125 | October 2026 </span>
            </li>
            <li className="list-inline-item">&sdot;</li>
            <li className="list-inline-item">
              <a
                id="llycw-cookie-settings-link"
                href="/cookie-settings"
                title="Cookie Settings"
                aria-label="Cookie Settings"
                style={{ color: "#0078A3", cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  if (window.CassieWidgetLoader && window.CassieWidgetLoader.Widget) {
                    window.CassieWidgetLoader.Widget.showModal();
                  }
                }}
              >
                Cookie Settings
              </a>
            </li>
            <li className="list-inline-item">&sdot;</li>
            <li className="list-inline-item">
              <a href="https://privacynotice.lilly.com/terms-of-use" rel="noopener noreferrer" target="_blank" style={{ color: '#0078A3' }}>Terms of Use</a>
            </li>
            <li className="list-inline-item">&sdot;</li>
            <li className="list-inline-item">
              <a href="https://privacynotice.lilly.com/global" rel="noopener noreferrer" target="_blank" style={{ color: '#0078A3' }}>Privacy Statement</a>
            </li>
            <li className="list-inline-item">&sdot;</li>
            <li className="list-inline-item">
              <a href="https://privacynotice.lilly.com/accessibility" rel="noopener noreferrer" target="_blank" style={{ color: '#0078A3' }}>Accessibility Statement</a>
            </li>
          </ul>
          <p className="copyright-txt small mb-4 mb-lg-0">
            <a href="https://www.lilly.com/uk/copyright" rel="noopener noreferrer" target="_blank" style={{ color: '#0078A3' }}>Copyright</a>
            {' '}
            © 2026 Eli Lilly and Company. All rights reserved.
            <br />
            The PARM Diabetes tool is developed and funded by Eli Lilly & Company Ltd.
          </p>
        </div>
        <div className="col-lg-6 h-100 text-center text-lg-right my-auto">
          <ul className="list-inline mb-0">
            <li className="list-inline-item mr-3">
              <span>
                <img src="public/img/LillyLogo_1.png" alt="lilly-logo" width="90" />
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
